[
  {
    "code": "GH-AH",
    "name": "Ashanti"
  },
  {
    "code": "GH-BA",
    "name": "Brong-Ahafo"
  },
  {
    "code": "GH-CP",
    "name": "Central"
  },
  {
    "code": "GH-EP",
    "name": "Eastern"
  },
  {
    "code": "GH-AA",
    "name": "Greater Accra"
  },
  {
    "code": "GH-NP",
    "name": "Northern"
  },
  {
    "code": "GH-UE",
    "name": "Upper East"
  },
  {
    "code": "GH-UW",
    "name": "Upper West"
  },
  {
    "code": "GH-TV",
    "name": "Volta"
  },
  {
    "code": "GH-WP",
    "name": "Western"
  }
]